import * as React from "react";
function SvgHeartbeat(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.857 10.694a1 1 0 00-1.69-.04l-1.702 2.554H1v2h6.535l1.42-2.13.688 1.145 1.5 2.5a1 1 0 001.751-.067l1.277-2.553.829 1.105h8v-2h-7l-1.2-1.6a1 1 0 00-1.694.153l-1.186 2.37-2.063-3.437zm-7.002-4.58c.833-1.569 2.329-2.906 4.285-2.906 1.806 0 3.249.925 4.185 1.75.256.226.481.45.675.66.193-.21.42-.434.675-.66.936-.825 2.379-1.75 4.184-1.75 1.92 0 3.397 1.288 4.237 2.816.827 1.507 1.156 3.438.693 5.184h-2.117a2.768 2.768 0 00.165-.444c.343-1.206.128-2.643-.494-3.777-.627-1.141-1.543-1.779-2.484-1.779-1.11 0-2.097.576-2.861 1.25a7.652 7.652 0 00-1.096 1.204l-.053.075-.01.016a1 1 0 01-1.678 0l-.063-.09a7.636 7.636 0 00-1.096-1.204c-.765-.675-1.751-1.25-2.862-1.25-.958 0-1.892.663-2.518 1.843-.62 1.17-.809 2.641-.418 3.848.03.092.071.195.124.308H2.21c-.455-1.714-.145-3.604.644-5.093zM14.73 17.209h2.782a84.399 84.399 0 01-2.795 2.822 99.45 99.45 0 01-2.007 1.884l-.03.027-.01.01a1 1 0 01-1.34 0l-.01-.01-.03-.027a90.301 90.301 0 01-.541-.496c-.363-.337-.874-.816-1.466-1.388a84.585 84.585 0 01-2.796-2.822H9.27A92.235 92.235 0 0012 19.85a98.441 98.441 0 002.73-2.642z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgHeartbeat);
export default ForwardRef;
